<template>
    <div class="custom-select-wrapper">
        <label :class="labelClasses"><slot></slot></label>
        <select :name="name">
            <option value=""></option>
            <option
                v-for="(option, index) in options"
                :key="index"
                :value="option.value"
            >{{ option.text }}</option>
        </select>
    </div>
</template>

<script>
export default {
    name: 'custom-select',

    data() {
        return {
            isSelected: null,
        };
    },

    props: {
        /**
         * @typedef Option {Object}
         * @property value
         * @property text
         */

        /**
         * Array<Option>
         */
        options: {
            type: Array,
        },

        name: {
            type: String,
        },
    },

    methods: {
        bindEvents() {
            $(this.$el).on('change', ({ target }) => {
                this.isSelected = $(this.$el.querySelector('select')).val();

                this.$emit('input', target.value);
            });
        },

        initCustomSelect() {
            $(this.$el.querySelector('select')).select2({
                minimumResultsForSearch: -1,
                width: '100%',
                placeholder: '', // нужен пустой option
                allowClear: false,
            });
        },
    },

    computed: {
        labelClasses() {
            return {
                'custom-select-wrapper__label': true,
                'custom-select-wrapper__label--empty': !this.isSelected,
            };
        },
    },

    mounted() {
        this.initCustomSelect();
        this.bindEvents();

        this.isSelected = $(this.$el.querySelector('select')).val();
    },
};
</script>
